import { Stack } from "@mui/material";
import { LockIcon } from "Assets/icons/attributes";
import { PATHS } from "constants/routes";

type Props = {
  size?: number;
  onClick?: (event: React.MouseEvent) => void;
  preventDefault?: boolean;
};

const LockButton = ({ size = 20, onClick, preventDefault = false }: Props) => {
  const handleClick = (event: React.MouseEvent) => {
    if (onClick) {
      onClick(event);
    }
    
    if (preventDefault) {
      event.preventDefault();
    }
  };

  return (
    <Stack
      sx={{
        width: size,
        height: size,
        cursor: "pointer",
        "&:hover": {
          opacity: 0.8,
        },
      }}
    >
      <a href={PATHS.pricing} target="_blank" rel="noreferrer" onClick={handleClick}>
        <LockIcon />
      </a>
    </Stack>
  );
};

export default LockButton;
